import { useState, useEffect } from 'react';
import { Menu, X } from 'lucide-react';
import { siteData } from '../data/mock';

export const Header = () => {
  const [scrolled, setScrolled] = useState(false);
  const [menuOpen, setMenuOpen] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 60);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  const handleNavClick = () => {
    setMenuOpen(false);
  };

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-500 ${
        scrolled
          ? 'bg-[#0d0f12]/95 backdrop-blur-md border-b border-[rgba(0,212,255,0.08)]'
          : 'bg-transparent'
      }`}
    >
      <div className="max-w-[87.5rem] mx-auto w-full px-5 md:px-10 flex items-center justify-between h-16 md:h-20">
        {/* Logo */}
        <a
          href="#"
          onClick={(e) => {
            e.preventDefault();
            window.scrollTo({ top: 0, behavior: 'smooth' });
          }}
          className="flex items-center gap-3 group"
        >
          <img
            src={siteData.images.logo}
            alt="G.S. Rylan"
            className="h-12 w-12 object-contain transition-transform duration-300 group-hover:scale-105"
          />
        </a>

        {/* Desktop Nav */}
        <nav className="hidden md:flex items-center gap-1">
          {siteData.nav.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={handleNavClick}
              className="nav-link px-5 py-2 text-[#e8e6e1] font-montserrat font-medium text-sm tracking-wide uppercase transition-colors duration-300 hover:text-[#00d4ff] relative"
            >
              {item.label}
            </a>
          ))}
        </nav>

        {/* Mobile Menu Toggle */}
        <button
          className="md:hidden text-[#e8e6e1] p-2"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="Toggle menu"
        >
          {menuOpen ? <X size={24} /> : <Menu size={24} />}
        </button>
      </div>

      {/* Mobile Nav */}
      <div
        className={`md:hidden overflow-hidden transition-all duration-500 ease-in-out ${
          menuOpen ? 'max-h-80 opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <nav className="flex flex-col bg-[#0d0f12]/98 backdrop-blur-lg border-t border-[rgba(0,212,255,0.08)] px-6 pb-6">
          {siteData.nav.map((item) => (
            <a
              key={item.label}
              href={item.href}
              onClick={handleNavClick}
              className="py-4 text-[#e8e6e1] font-montserrat font-medium text-sm tracking-wide uppercase border-b border-[rgba(255,255,255,0.05)] transition-colors duration-300 hover:text-[#00d4ff]"
            >
              {item.label}
            </a>
          ))}
        </nav>
      </div>
    </header>
  );
};
